import { useState, useEffect} from 'react';
import { toggleFilterValue } from '../../helpers';
import appConstants from "../../../../constants";

const defaults = Object.freeze({
  initialSelectedPartnerExpertises: [],
  incomingLinkExpertise: null,
});

export function getComputedPartnerExpertiseList(selectedPartnerRoleCode, partnerIntegratorExpertiseList, partnerProviderExpertiseList, searchParameters) {
  switch (selectedPartnerRoleCode) {
    case appConstants.VALUE_INTEGRATOR : {
      return partnerIntegratorExpertiseList;
    }
    case appConstants.VALUE_PROVIDER : {
      return partnerProviderExpertiseList;
    }
    default: {
      return [];
    }
  }
}

export default function usePartnerExpertiseFilter(
  selectedPartnerRoleCode,
  partnerIntegratorSpecializationList,
  partnerProviderCiscoPoweredServiceList,
  partnerDeveloperSpecializationList,
  partnerAdvisorSpecializationList,
  initialSelectedPartnerExpertises = defaults.initialSelectedPartnerExpertises,
  incomingLinkExpertise = defaults.incomingLinkExpertise
) {
  const [isPartnerExpertiseFilterDropdownOpened, setIsPartnerExpertiseFilterDropdownOpened] = useState(false);
  const [partnerExpertiseFilterValues, setPartnerExpertiseFilterValues] = useState([]);

  const [selectedPartnerExpertises, setSelectedPartnerExpertises] = useState(initialSelectedPartnerExpertises);

  function togglePartnerExpertiseFilterValue(partnerExpertiseFilterValue) {
    const updatePartnerExpertiseFilterOperationResults =
      toggleFilterValue(partnerExpertiseFilterValue, partnerExpertiseFilterValues);
    if (updatePartnerExpertiseFilterOperationResults.areFilterValuesUpdated) {
      setPartnerExpertiseFilterValues(previousValue => [...updatePartnerExpertiseFilterOperationResults.updatedFilterValues]);
      setIsPartnerExpertiseFilterDropdownOpened(previousValue => false);
      setSelectedPartnerExpertises((previousValue) => [...updatePartnerExpertiseFilterOperationResults.updatedFilterValues.filter((partnerExpertise) => partnerExpertise[appConstants.KEY_IS_SELECTED] === true)]);
    }
  }
  function resetPartnerExpertiseFilterValues() {
    setPartnerExpertiseFilterValues(previousValue => [...getComputedPartnerExpertiseList(selectedPartnerRoleCode, partnerIntegratorSpecializationList, partnerProviderCiscoPoweredServiceList)]);
    setSelectedPartnerExpertises((previousValue) => defaults.initialSelectedPartnerExpertises);
  }
  function togglePartnerExpertiseFilterDropdown() {
    setIsPartnerExpertiseFilterDropdownOpened(previousValue => !isPartnerExpertiseFilterDropdownOpened);
  }

  useEffect(
    () => {
      let updatedPartnerExpertiseList = getComputedPartnerExpertiseList(selectedPartnerRoleCode, partnerIntegratorSpecializationList, partnerProviderCiscoPoweredServiceList);

      if (!!incomingLinkExpertise && !!incomingLinkExpertise.length) {
        const toBeSelectedExpertise = incomingLinkExpertise.toUpperCase();
        // an expertise query string param was found;
        // one therefore tries to select the corresponding expertise filter value.
        updatedPartnerExpertiseList =
          updatedPartnerExpertiseList.map(partnerExpertise => {
            if (partnerExpertise?.[appConstants.KEY_ORIGINAL_DATA]?.[appConstants.KEY_KEYWORD_SUBTEXT] === toBeSelectedExpertise) {
              // mark the filter expertise identified from the query string param as selected.
              return { ...partnerExpertise, [appConstants.KEY_IS_SELECTED]: true }
            }
            else {
              return partnerExpertise;
            }
          });

        setPartnerExpertiseFilterValues(previousValue => [...updatedPartnerExpertiseList]);

      }
      else {
        if (
          (initialSelectedPartnerExpertises !== null) &&
          Array.isArray(initialSelectedPartnerExpertises) &&
          !!initialSelectedPartnerExpertises.length) {
          initialSelectedPartnerExpertises.forEach((selectedPartnerExpertise) => {
            updatedPartnerExpertiseList = updatedPartnerExpertiseList.map((partnerExpertise) => partnerExpertise[appConstants.KEY_CODE] === selectedPartnerExpertise[appConstants.KEY_CODE] ? selectedPartnerExpertise : partnerExpertise)
          });
        }
        setPartnerExpertiseFilterValues(previousValue => [...updatedPartnerExpertiseList]);
      }
    },
    [partnerIntegratorSpecializationList, partnerProviderCiscoPoweredServiceList, selectedPartnerRoleCode, initialSelectedPartnerExpertises, incomingLinkExpertise]
  );

  return {
    isPartnerExpertiseFilterDropdownOpened,
    partnerExpertiseFilterValues,
    togglePartnerExpertiseFilterValue,
    resetPartnerExpertiseFilterValues,
    togglePartnerExpertiseFilterDropdown,
    selectedPartnerExpertises
  }

}
